export default __webpack_public_path__ + "static/media/SharpGroteskBook20-Regular.6eb4af5e.woff2";